import { render, staticRenderFns } from "./DetailMessage.vue?vue&type=template&id=2e5f9582&scoped=true&"
import script from "./DetailMessage.vue?vue&type=script&lang=js&"
export * from "./DetailMessage.vue?vue&type=script&lang=js&"
import style0 from "./DetailMessage.vue?vue&type=style&index=0&id=2e5f9582&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5f9582",
  null
  
)

export default component.exports